import { render, staticRenderFns } from "./app-logo.vue?vue&type=template&id=d9ec72b4&"
import script from "./app-logo.vue?vue&type=script&lang=js&"
export * from "./app-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports